import React from 'react';
import Navbar from '../layout/Navbar';
import HeroSection from './HeroSection';
import AboutSection from './AboutSection';
import ServicesSection from './ServicesSection';
import AboutMeSection from './AboutMeSection';
import ContactSection from './ContactSection';
import Footer from '../layout/Footer';
import GlobalStyles from '../layout/GlobalStyles';

const LandingPage = () => {
  return (
    <>
      <GlobalStyles />
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <AboutMeSection />
      <ContactSection />
      <Footer />
    </>
  );
};

export default LandingPage;